import tasksApi from '@/api/tasks';

const state = {
    tasksCreated: null,
    tasksUpdated: null,
    tasksRemoved: null,
    tasksChecked: null,
    isLoading: false,
    validationErrors: null,
}

export const mutationTypes = {
    tasksAddStart: '[tasks] Create tasks start',
    tasksAddSuccess: '[tasks] Create tasks success',
    tasksAddFailure: '[tasks] Create tasks failure',

    tasksEditStart: '[tasks] Update tasks start',
    tasksEditSuccess: '[tasks] Update tasks success',
    tasksEditFailure: '[tasks] Update tasks failure',

    tasksRemoveStart: '[tasks] Remove tasks start',
    tasksRemoveSuccess: '[tasks] Remove tasks success',
    tasksRemoveFailure: '[tasks] Remove tasks failure',

    tasksCheckStart: '[tasks] Check tasks start',
    tasksCheckSuccess: '[tasks] Check tasks success',
    tasksCheckFailure: '[tasks] Check tasks failure',
}

export const tasksActionTypes = {
    getTasksList: '[tasksList] Get tasks list',
    tasksAdd: '[tasks] Create tasks',
    tasksEdit: '[tasks] Update tasks',
    tasksRemove: '[tasks] Remove tasks',
    tasksCheck: '[tasks] Check tasks'
}

const mutations = {
    [mutationTypes.tasksAddStart](state) {
        state.isLoading = true
        state.tasksCreated = null
    },
    [mutationTypes.tasksAddSuccess](state, payload) {
        state.isLoading = false
        state.tasksCreated = payload
        state.validationErrors = null
    },
    [mutationTypes.tasksAddFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.tasksEditStart](state) {
        state.isLoading = true
        state.tasksUpdated = null
    },
    [mutationTypes.tasksEditSuccess](state, payload) {
        state.isLoading = false
        state.tasksUpdated = payload
        state.validationErrors = null
    },
    [mutationTypes.tasksEditFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.tasksRemoveStart](state) {
        state.isLoading = true
        state.tasksRemoved = null
    },
    [mutationTypes.tasksRemoveSuccess](state, payload) {
        state.isLoading = false
        state.tasksRemoved = payload
        state.validationErrors = null
    },
    [mutationTypes.tasksRemoveFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.tasksCheckStart](state) {
        state.isLoading = true
        state.tasksChecked = null
    },
    [mutationTypes.tasksCheckSuccess](state, payload) {
        state.isLoading = false
        state.tasksChecked = payload
        state.validationErrors = null
    },
    [mutationTypes.tasksCheckFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    }
}

const actions = {
    [tasksActionTypes.tasksAdd](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.tasksAddStart)
            tasksApi
                .tasksAdd(data)
                .then(response => {
                    context.commit(mutationTypes.tasksAddSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.tasksAddFailure,response)
                })
        })
    },
    [tasksActionTypes.tasksEdit](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.tasksEditStart)
            tasksApi
                .tasksEdit(data)
                .then(response => {
                    context.commit(mutationTypes.tasksEditSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.tasksEditFailure,response)
                })
        })
    },
    [tasksActionTypes.tasksRemove](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.tasksRemoveStart)
            tasksApi
                .tasksRemove(data)
                .then(response => {
                    context.commit(mutationTypes.tasksRemoveSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.tasksRemoveFailure,response)
                })
        })
    },
    [tasksActionTypes.tasksCheck](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.tasksCheckStart)
            tasksApi
                .tasksCheck(data)
                .then(response => {
                    context.commit(mutationTypes.tasksCheckSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.tasksCheckFailure,response)
                })
        })
    }
}

export default {
    state,
    actions,
    mutations
}